import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Button, DrawerBodyWrapper, DrawerFooterWrapper, Textarea, TOAST_TYPE } from '@base'
import { strings } from '@constants'
import { editEnquiryQuote } from '@data'
import { showLoader, showToast } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'

const EditSpoTerms = ({ update, enquiryId, enquiry, quote }) => {
	const dispatch = useDispatch()
	const [terms, setTerms] = useState(quote?.terms)
	const user = useSelector((state) => state.getIn(['user', 'user']))

	const editSpoTermsHandler = () => {
		dispatch(showLoader(true))

		editEnquiryQuote(user, enquiry?.enquiry_id, { ...quote, terms: terms })
			.then((response) => {
				update()
				dispatch(showToast(true, strings('msg_spo_terms_edit_success'), { type: TOAST_TYPE.SUCCESS }))
			})
			.catch((error) => {
				let error_msg = error?.error_msg ?? strings('msg_spo_terms_edit_failed')
				dispatch(showToast(true, error_msg, { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => {
				dispatch(showLoader(false))
				dispatch(toggleDrawer(false))
			})
	}

	return (
		<>
			<DrawerBodyWrapper>
				<Textarea
					id='quote-message'
					label={strings(['terms_and_conditions'])}
					type='text'
					rows={10}
					// placeholder={strings('msg_share_any_more_details')}
					value={terms}
					onChange={(val) => setTerms(val)}
				/>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button small margin={`0 0 0 0`} onClick={editSpoTermsHandler}>
					{strings('edit')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default EditSpoTerms
